import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import i18n from '@/lang/i18n';
import FirmwareVersionAutoComplete from '@/components/AutoCompletes/FirmwareVersionAutoComplete.vue';
import SingleDeviceTypeAutoComplete from '@/components/AutoCompletes/SingleDeviceTypeAutoComplete.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import FirmwareVersionsType from '@/types/FirmwareVersionsType';
import deviceType from '@/types/DeviceType';
import FirmwareTargetDeviceType from '@/types/FirmwareTargetDeviceType';
import {
  TARGET_CATEGORY_OPERATION_OFFICE,
  TARGET_CATEGORY_DEVICE_TYPE,
  TARGET_CATEGORY_FIRMWARE,
  TARGET_CATEGORYS
} from '@/services/consts/firmware_bulk_update';


export default /*@__PURE__*/_defineComponent({
  __name: 'TargetDevice',
  props: {
    modelValue: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

const selectedOperationOffice = ref<getOperationOffice>()
const selectedDeviceType = ref<deviceType>()
const firmware = ref<FirmwareVersionsType>()

function targetSelectHandler(category: string) {
  switch(category) {
    case 'operationOffice':
      modelValue.value = {category: 'operationOffice', target: selectedOperationOffice.value}
      break
    case 'deviceType':
      modelValue.value = {category: 'deviceType', target: selectedDeviceType.value}
      break
    case 'firmware':
      modelValue.value = {category: 'firmware', target: firmware.value}
      break
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "fw-bold" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.targetDevice.name')) + " ", 1),
            _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              label: _unref(i18n).global.t('pages.firmwareBulkUpdate.targetDevice.category'),
              modelValue: modelValue.value.category,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.category) = $event)),
              items: _unref(TARGET_CATEGORYS),
              "error-messages": __props.errorMessages['target_category']
            }, null, 8, ["label", "modelValue", "items", "error-messages"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            (modelValue.value.category == _unref(TARGET_CATEGORY_OPERATION_OFFICE))
              ? (_openBlock(), _createBlock(SingleOperationOfficeAutoComplete, {
                  key: 0,
                  modelValue: selectedOperationOffice.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((selectedOperationOffice).value = $event)),
                    _cache[2] || (_cache[2] = ($event: any) => (targetSelectHandler('operationOffice')))
                  ],
                  initialOperationId: modelValue.value?.target?.id,
                  "error-messages": __props.errorMessages['target_id']
                }, null, 8, ["modelValue", "initialOperationId", "error-messages"]))
              : (modelValue.value.category == _unref(TARGET_CATEGORY_DEVICE_TYPE))
                ? (_openBlock(), _createBlock(SingleDeviceTypeAutoComplete, {
                    key: 1,
                    modelValue: selectedDeviceType.value,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((selectedDeviceType).value = $event)),
                      _cache[4] || (_cache[4] = ($event: any) => (targetSelectHandler('deviceType')))
                    ],
                    initialItemId: modelValue.value?.target?.id,
                    "error-messages": __props.errorMessages['target_id']
                  }, null, 8, ["modelValue", "initialItemId", "error-messages"]))
                : (modelValue.value.category == _unref(TARGET_CATEGORY_FIRMWARE))
                  ? (_openBlock(), _createBlock(FirmwareVersionAutoComplete, {
                      key: 2,
                      modelValue: firmware.value,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((firmware).value = $event)),
                        _cache[6] || (_cache[6] = ($event: any) => (targetSelectHandler('firmware')))
                      ],
                      initialItemId: modelValue.value?.target?.id,
                      "error-messages": __props.errorMessages['target_id']
                    }, null, 8, ["modelValue", "initialItemId", "error-messages"]))
                  : (_openBlock(), _createBlock(_component_v_select, {
                      key: 3,
                      label: _unref(i18n).global.t('pages.firmwareBulkUpdate.targetDevice.selectCategory'),
                      disabled: ""
                    }, null, 8, ["label"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})